import React from "react";
import ReactDOM from "react-dom";
import MarketStockHeader from "./containers/MarketStockHeader";
import { getElementsProperty } from "../helpers/getElementsProperty";

export const initMarketStockHeaders = className => {
  getElementsProperty(className, (property, element) => {
    ReactDOM.render(<MarketStockHeader symbol={property.symbol} />, element);
  });
};
